import extendNode from '../extendNode.mjs'
import useCategoryNode from '../_CATEGORY/useCategoryNode.jsx'
import meta from './metaFcReq.mjs'

export default () => {
    const CategoryNode = useCategoryNode()

    return extendNode(CategoryNode, {
        ...meta,

        canMountType(map, node, type) {
            return /^(REQ)$/.test(type)
        },

        menuItemsInsertConcept(map, node) {
            return [
                {type: 'REQ'},
            ]
        },
    })
}
